/*const weatherConditionMap = {
    // ☀️ SUNNY
    "sunny": "sunny",
    "clear": "sunny",
  
    // ☁️ CLOUDS
    "partly cloudy": "clouds",
    "cloudy": "clouds",
    "overcast": "clouds",
  
    // 🌫️ FOG
    "mist": "fog",
    "fog": "fog",
    "freezing fog": "fog",
  
    // 🌧️ RAIN
    "patchy rain possible": "rain",
    "light drizzle": "rain",
    "patchy light drizzle": "rain",
    "moderate rain": "rain",
    "moderate rain at times": "rain",
    "heavy rain": "rain",
    "heavy rain at times": "rain",
    "light rain": "rain",
    "patchy light rain": "rain",
    "light rain shower": "rain",
    "moderate or heavy rain shower": "rain",
    "torrential rain shower": "rain",
    "freezing drizzle": "rain",
    "heavy freezing drizzle": "rain",
    "freezing rain": "rain",
    "light freezing rain": "rain",
    "moderate or heavy freezing rain": "rain",
  
    // ❄️ SNOW
    "patchy snow possible": "snow",
    "blowing snow": "snow",
    "blizzard": "snow",
    "patchy light snow": "snow",
    "light snow": "snow",
    "patchy moderate snow": "snow",
    "moderate snow": "snow",
    "patchy heavy snow": "snow",
    "heavy snow": "snow",
    "light snow showers": "snow",
    "moderate or heavy snow showers": "snow",
    "light sleet": "snow",
    "moderate or heavy sleet": "snow",
    "patchy sleet possible": "snow",
    "light sleet showers": "snow",
    "moderate or heavy sleet showers": "snow",
    "ice pellets": "snow",
    "light showers of ice pellets": "snow",
    "moderate or heavy showers of ice pellets": "snow",
  
    // ⛈️ THUNDER
    "thundery outbreaks possible": "thunder",
    "moderate or heavy rain with thunder": "thunder",
    "patchy light rain with thunder": "thunder",
    "patchy light snow with thunder": "thunder",
    "moderate or heavy snow with thunder": "thunder",
  
    // Fallback
    "default": "clouds"
  };
  
  export default weatherConditionMap;
  */

  const weatherConditionMap = {
    // ☀️
    "sunny": "sunny",
    "clear": "clear",
  
    // ☁️
    "cloudy": "clouds",
    "overcast": "clouds",
  
    // 🌫️
    "fog": "fog",
    "mist": "fog",
  
    // 🌧️
    "rain": "rain",
    "drizzle": "rain",
  
    // ❄️
    "snow": "snow",
    "sleet": "snow",
    "pellets": "snow",
  
    // ⛈️
    "thunder": "thunder",
  };
  
  export default weatherConditionMap;
  